import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacidad' | 'legal' | 'contacto' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-113">
      <div className="bg-card rounded-2xl shadow-2xl border border-border w-full max-w-lg max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-114">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border" data-id="element-115">
          <h2 className="text-lg font-bold text-foreground" data-id="element-116">
            {type === 'privacidad' && 'Política de Privacidad'}
            {type === 'legal' && 'Aviso Legal'}
            {type === 'contacto' && 'Contacto'}
          </h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-muted transition-colors duration-150" data-id="element-117">
            <XIcon className="w-4 h-4 text-muted-foreground" data-id="element-118" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 text-sm text-muted-foreground leading-relaxed flex flex-col gap-4" data-id="element-119">
          {type === 'privacidad' && <>
              <p className="font-semibold text-foreground" data-id="element-120">
                1. Responsable del tratamiento
              </p>
              <p data-id="element-121">
                Trimora (Glowlift Essence MX) es el responsable del tratamiento
                de los datos personales recogidos a través de este sitio web.
              </p>
              <p className="font-semibold text-foreground" data-id="element-122">
                2. Datos que recopilamos
              </p>
              <p data-id="element-123">
                Recopilamos datos de identificación (nombre, email) y datos de
                navegación con el único fin de gestionar pedidos y mejorar la
                experiencia del usuario.
              </p>
              <p className="font-semibold text-foreground" data-id="element-124">
                3. Finalidad del tratamiento
              </p>
              <p data-id="element-125">
                Los datos se utilizan exclusivamente para procesar pedidos,
                enviar confirmaciones de compra y, con tu consentimiento,
                comunicaciones comerciales.
              </p>
              <p className="font-semibold text-foreground" data-id="element-126">
                4. Derechos del usuario
              </p>
              <p data-id="element-127">
                Puedes ejercer tus derechos de acceso, rectificación, supresión
                y portabilidad escribiendo a{' '}
                <span className="text-green-700 font-medium" data-id="element-128">
                  info@glowliftessencemx.com
                </span>
                .
              </p>
              <p className="font-semibold text-foreground" data-id="element-129">5. Cookies</p>
              <p data-id="element-130">
                Este sitio utiliza cookies técnicas necesarias para su
                funcionamiento. No se utilizan cookies de seguimiento sin
                consentimiento previo.
              </p>
            </>}
          {type === 'legal' && <>
              <p className="font-semibold text-foreground" data-id="element-131">
                1. Titular del sitio
              </p>
              <p data-id="element-132">
                Glowlift Essence MX · Contacto:{' '}
                <span className="text-green-700 font-medium" data-id="element-133">
                  info@glowliftessencemx.com
                </span>
              </p>
              <p className="font-semibold text-foreground" data-id="element-134">
                2. Objeto y ámbito de aplicación
              </p>
              <p data-id="element-135">
                El presente aviso legal regula el uso del sitio web de Trimora.
                El acceso y uso del sitio implica la aceptación plena de las
                condiciones aquí recogidas.
              </p>
              <p className="font-semibold text-foreground" data-id="element-136">
                3. Propiedad intelectual
              </p>
              <p data-id="element-137">
                Todos los contenidos de este sitio (textos, imágenes, logotipos)
                son propiedad de Trimora o de sus licenciantes y están
                protegidos por la legislación vigente.
              </p>
              <p className="font-semibold text-foreground" data-id="element-138">
                4. Responsabilidad
              </p>
              <p data-id="element-139">
                Trimora es un complemento alimenticio. No sustituye una dieta
                equilibrada ni un estilo de vida saludable. Los resultados
                pueden variar entre personas. Este producto no está destinado a
                diagnosticar, tratar, curar ni prevenir ninguna enfermedad.
              </p>
              <p className="font-semibold text-foreground" data-id="element-140">
                5. Legislación aplicable
              </p>
              <p data-id="element-141">
                Las presentes condiciones se rigen por la legislación española y
                europea vigente en materia de comercio electrónico y protección
                de datos.
              </p>
            </>}
          {type === 'contacto' && <>
              <p className="text-foreground" data-id="element-142">
                ¿Tienes alguna pregunta sobre tu pedido o nuestro producto?
                Estamos aquí para ayudarte.
              </p>
              <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex flex-col gap-2" data-id="element-143">
                <p className="font-semibold text-green-800" data-id="element-144">📧 Email</p>
                <a href="mailto:info@glowliftessencemx.com" className="text-green-700 font-medium hover:underline" data-id="element-145">
                  info@glowliftessencemx.com
                </a>
              </div>
              <div className="bg-muted rounded-xl p-4 flex flex-col gap-1" data-id="element-146">
                <p className="font-semibold text-foreground text-xs uppercase tracking-wide" data-id="element-147">
                  Horario de atención
                </p>
                <p data-id="element-148">Lunes a Viernes · 9:00 — 18:00 (CET)</p>
              </div>
              <p data-id="element-149">
                Respondemos en un plazo máximo de{' '}
                <strong className="text-foreground" data-id="element-150">
                  24–48 horas laborables
                </strong>
                .
              </p>
            </>}
        </div>
      </div>
    </div>;
}
export function FooterDisclaimer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <Modal type={openModal} onClose={() => setOpenModal(null)} data-id="element-151" />

      <footer className="bg-muted border-t border-border" data-id="element-152">
        {/* Top footer */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-153">
          <div className="flex flex-col items-center gap-6 text-center" data-id="element-154">
            {/* Logo + tagline */}
            <div className="flex flex-col items-center gap-1" data-id="element-155">
              <span className="text-2xl font-bold text-green-700" data-id="element-156">
                🌿 Trimora
              </span>
              <span className="text-sm text-muted-foreground font-medium" data-id="element-157">
                Fórmula GLP-1+NAD+ · Complemento Premium
              </span>
            </div>

            {/* Quick links */}
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-muted-foreground" data-id="element-158">
              <button onClick={() => setOpenModal('privacidad')} className="hover:text-foreground transition-colors duration-150 underline-offset-2 hover:underline" data-id="element-159">
                Política de privacidad
              </button>
              <span className="text-border" data-id="element-160">·</span>
              <button onClick={() => setOpenModal('legal')} className="hover:text-foreground transition-colors duration-150 underline-offset-2 hover:underline" data-id="element-161">
                Aviso legal
              </button>
              <span className="text-border" data-id="element-162">·</span>
              <button onClick={() => setOpenModal('contacto')} className="hover:text-foreground transition-colors duration-150 underline-offset-2 hover:underline" data-id="element-163">
                Contacto
              </button>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-164">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full text-xs font-medium text-muted-foreground" data-id="element-165">
                🔒 SSL Seguro
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full text-xs font-medium text-muted-foreground" data-id="element-166">
                ✅ GDPR Compliant
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full text-xs font-medium text-muted-foreground" data-id="element-167">
                🌿 Natural
              </span>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-border" data-id="element-168"></div>

            {/* Disclaimer */}
            <p className="text-xs text-muted-foreground max-w-2xl leading-relaxed" data-id="element-169">
              Trimora es un complemento alimenticio. No sustituye una dieta
              equilibrada ni un estilo de vida saludable. Los resultados pueden
              variar. Este producto no está destinado a diagnosticar, tratar,
              curar ni prevenir ninguna enfermedad. Consulta con tu médico antes
              de comenzar cualquier suplementación.
            </p>

            <p className="text-xs text-muted-foreground" data-id="element-170">
              © 2024 Trimora. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </>;
}